/**
 * Provider presentation layer (spec §13). The registry API controls
 * AVAILABILITY; this config controls only copy + the reviewed asset mapping.
 */
import type { ProviderId, ProviderView } from '../api/apiSchemas';

export interface ProviderPresentation {
  id: ProviderId;
  displayName: string;
  loginLabel: string;
  linkLabel: string;
  /** Path under /public to an approved brand asset (spec §13.3/§13.4). */
  iconAsset: string;
}

const PRESENTATION: Record<ProviderId, ProviderPresentation> = {
  google: {
    id: 'google',
    displayName: 'Google',
    loginLabel: 'Tiếp tục với Google',
    linkLabel: 'Liên kết Google',
    iconAsset: '/provider-assets/google-g.svg',
  },
  linkedin: {
    id: 'linkedin',
    displayName: 'LinkedIn',
    loginLabel: 'Tiếp tục với LinkedIn',
    linkLabel: 'Liên kết LinkedIn',
    iconAsset: '/provider-assets/linkedin.svg',
  },
  facebook: {
    id: 'facebook',
    displayName: 'Facebook',
    loginLabel: 'Tiếp tục với Facebook',
    linkLabel: 'Liên kết Facebook',
    iconAsset: '/provider-assets/facebook.svg',
  },
};

export function getPresentation(id: ProviderId): ProviderPresentation {
  return PRESENTATION[id];
}

/** Providers eligible to render as login buttons, sorted by priority (spec §10.2). */
export function loginProviders(providers: ProviderView[]): ProviderView[] {
  return providers
    .filter((p) => p.enabled && p.supportsLogin)
    .slice()
    .sort((a, b) => a.priority - b.priority);
}

/** Providers eligible to render as link actions, sorted by priority. */
export function linkableProviders(providers: ProviderView[]): ProviderView[] {
  return providers
    .filter((p) => p.enabled && p.supportsLink)
    .slice()
    .sort((a, b) => a.priority - b.priority);
}
